const state = {
    showLoadingPage: false, // control show top loading bar or not
    showOverlay: false, // control show overlay or not
    alertMessage: { // AlertBox props 
        show: false,
        message: '',
        type: 'success',
        refresh: false,
        redirect: '',
    },
    isLoading: false, // tells submission/upload is processing or not
    isUploading: false, // tells upload is processing or not
    dataIsUpdated: false, // tells details is edited without saving or not
}

const getters = {
    showLoadingPage: state => state.showLoadingPage,
    alertMessage: state => state.alertMessage,
    showOverlay: state => state.showOverlay,
    isLoading: state => state.isLoading,
    isUploading: state => state.isUploading,
    dataIsUpdated: state => state.dataIsUpdated,
}

const actions = {
    toggleLoadingPage({ commit }, data = false) {
        commit('setLoadingPage', data)
    },
    toggleAlertMessage({ commit }, data = null) {
        if (data === null) {
            commit('toggleAlert', {
                show: false,
                message: '',
                type: 'success',
                refresh: false,
                redirect: ''
            })
        } else {
            const passData = JSON.parse(JSON.stringify(data));
            switch (data.message) {
                case 'processing':
                    passData.message = '資料處理中，請稍候...';
                    break;
                case 'required':
                    passData.message = '請填滿所有必填項目並確保輸入無誤';
                    break;
                case 'invValue':
                    passData.message = '請確保輸入無誤';
                    break;
                case 'noPermission':
                    passData.message = '你沒有權限進行此動作';
                    break;
            }
            commit('toggleAlert', passData)
        }
    },
    toggleOverlay({ commit }, data = false) {
        commit('setOverlay', data)
    },
    setLoading({ commit }, data = false) {
        commit('setLoading', data)
    },
    setUploadLoading({ commit }, data = false) {
        commit('setUploadLoading', data)
    },
    setDataIsUpdated({ commit }, data = false) {
        commit('setDataIsUpdated', data)
    },
}

const mutations = {
    setLoadingPage: function (state, bool) {
        state.showLoadingPage = bool
    },
    toggleAlert: function (state, data) {
        state.alertMessage = data
    },
    setOverlay: function (state, bool) {
        state.showOverlay = bool
    },
    setLoading: function (state, bool) {
        state.isLoading = bool;
    },
    setUploadLoading: function (state, bool) {
        state.isUploading = bool
    },
    setDataIsUpdated: function (state, bool) {
        state.dataIsUpdated = bool
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}